import React, { useEffect } from 'react';
import PublicRoutes from 'routes/PublicRoutes';
import PrivateRoutes from 'routes/PrivateRoutes';
import { auth, onAuthStateChanged } from 'config/firebase';
import axios from 'config/axios';
import AppWrapper from 'components/AppWrapper';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { store } from 'store';
import { signIn, signOut } from 'store/user';
import { initializeCart } from 'store/cart';

function App() {
    const { user, isAuthenticating } = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();

    const fetchData = async () => {
        try {
            const { data } = await axios.get('students/');

            // console.log(data);

            dispatch(signIn(data?.user));
        }
        catch (error) {
            if (error.code !== 'ERR_NETWORK') {
                dispatch(signIn(null));
            }
        }
        try {
            const { data } = await axios.get('payments/cart/');

            dispatch(initializeCart({
                bundles: data?.cartBundles,
            }));
        }
        catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                // console.log(user);
                fetchData();
            }
            else {
                dispatch(signOut());
            }
        });
    }, []);

    // useEffect(() => {
    //     console.log(store.getState());
    // });

    if (isAuthenticating) return <></>;

    return (
        <AppWrapper>
            {user
              ? <PrivateRoutes />
              : <PublicRoutes />
            }
        </AppWrapper>
    );
}

export default App;